import React from 'react';
export  var Loader = React.createClass({

    render() {

        return (

          <div id="" className="modal fade in" role="dialog" style={{display: 'block'}} >
                   <div className="modal-content-text create-facility-modal ">
                      <div className="modal-box">

                         <div>

                             <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                               <defs>
                                 <filter id="gooey">
                                   <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"></feGaussianBlur>
                                   <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo"></feColorMatrix>
                                   <feBlend in="SourceGraphic" in2="goo"></feBlend>
                                 </filter>
                               </defs>
                             </svg>
                             <div className="blob blob-0"></div>
                             <div className="blob blob-1"></div>
                             <div className="blob blob-2"></div>
                             <div className="blob blob-3"></div>
                             <div className="blob blob-4"></div>
                             <div className="blob blob-5"></div>
                         </div>
                      </div>
                   </div>
                </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/loader.jsx
 **/